import { useGetDataQuery } from "@/utils/react-query-hooks/getData";
import { useMemo } from "react";

export const gtdc_usePrepareThemeUpdatedBargraphData = ({ annotations }) => {

  
  const {
    data: tagThemesData,
    status,
    error,
    isLoading
  } = useGetDataQuery({
    contentTypes: ["themeTags"],
    findQuery: {
      kp_published_status: "published"
    },
    projection: {
       "main.title" :1,
       "tagId": 1,
       "tags": 1,
    }
  })

  return useMemo(() => {
    if (!tagThemesData?.data || !Array.isArray(tagThemesData?.data) || tagThemesData?.data.length === 0) {
      return [];
    }

    // Create a map to group items by theme tagId
    const themeMap = new Map();
    
    // Create a set to track which items we've already processed for each theme
    const processedItems = new Map();

    // First, process each input item to build the theme structure
    tagThemesData?.data.forEach((item) => {
      // Check if the item has themes data
      if (
        item?.tags?.themes?.data &&
        Array.isArray(item.tags.themes.data) &&
        item.tags.themes.data.length > 0
      ) {
        // For each theme in the item
        item.tags.themes.data.forEach((theme) => {
          const themeTagId = theme.tagId;
          
          // Initialize tracking set for this theme if it doesn't exist
          if (!processedItems.has(themeTagId)) {
            processedItems.set(themeTagId, new Set());
          }
          
          // Check if we've already processed this item for this theme
          if (processedItems.get(themeTagId).has(item._id)) {
            return; // Skip this item for this theme
          }
          
          // Mark this item as processed for this theme
          processedItems.get(themeTagId).add(item._id);
          
          if (!themeMap.has(themeTagId)) {
            // Initialize a new theme category
            themeMap.set(themeTagId, {
              tagCategory: theme.display,
              category: themeTagId,
              _id: theme._id,
              display: theme.display,
              totalCountOfAllTagsWithin: 0,
              tagSpecificCount: []
            });
          }
          
          // Get the current theme category
          const themeCategory = themeMap.get(themeTagId);
          
          // Add this item to the tagSpecificCount with count initialized to 0
          themeCategory.tagSpecificCount.push({
            tagId: item.tagId,
            display: item.main.title,
            _id: item._id,
            count: 0 // Initialize count to 0, will update later
          });
        });
      }
    });

    // Now, count occurrences of each theme tag in the annotations data
    if (annotations && Array.isArray(annotations)) {
      annotations.forEach(annotation => {
        // Check if the annotation has theme tags
        const themeTags = annotation?.annotations?.tags?.themeTags?.data;
        if (themeTags && Array.isArray(themeTags)) {
          // For each theme tag in the annotation
          themeTags.forEach(themeTag => {
            // Go through each theme category in our map
            themeMap.forEach(themeCategory => {
              // Check each tag specific count item
              themeCategory.tagSpecificCount.forEach(tagItem => {
                // If the _id matches, increment the count
                if (tagItem._id === themeTag._id) {
                  tagItem.count += 1;
                }
              });
            });
          });
        }
      });
    }

    // Update the total counts for each theme category
    themeMap.forEach(themeCategory => {
      // Count only items with count > 0
      themeCategory.totalCountOfAllTagsWithin = themeCategory.tagSpecificCount.filter(
        item => item.count > 0
      ).length;
    });

    // Convert the map to an array
    const result = Array.from(themeMap.values());



    return result.flatMap(category => 
      category.tagSpecificCount.map(tag => tag.count ? ({
        category: category.tagCategory,
        tagCategory: category.category,
        display: tag.display,
        value: tag.count
      }) : undefined).filter(Boolean)
    );

  }, [tagThemesData?.data, annotations]);
};